import classNames from "classnames"

export const AircraftColorTag = ({
    color,
    className,
}: {
    color: string | null
    className?: string
}) =>
    color ? (
        <div
            className={classNames("w-0.5 shrink-0 self-stretch rounded-full", className)}
            style={{ backgroundColor: color }}
        />
    ) : null
